import { ActionData, AttachmentCategory } from '@bonusly/common-action-input';

export const createTrackingData = (data: ActionData) => {
	const linkMatch = data.text.match(/(?:[^!]|^)\[(.*)]\((.*)\)/g);

	return {
		amount: data.totalAmount,
		flashPointsUsed: data.flashPointsUsed,
		gifIncluded: !!(data.attachment?.category === AttachmentCategory.Social), // Suggest we deprecate in favor of gifIncluded
		hasLink: !!linkMatch,
		hashtagsCount: data.hashtags.length,
		imageIncluded: !!(data.attachment?.category === AttachmentCategory.Image), // Suggest we deprecate in favor of gifIncluded
		video: !!(data.attachment?.category === AttachmentCategory.Video), // Uploaded videos
		social: !!(data.attachment?.category === AttachmentCategory.Social), // GIFs are in mp4 or gif format
		image: !!(data.attachment?.category === AttachmentCategory.Image), // Uploaded images
		spotlightIncluded: !!(data.attachment?.category === AttachmentCategory.EmployeeSpotlight), // Employee spotlight attachments
		recipientsCount: data.recipients.length,
		userTagsCount: data.mentions.length,
		wordCount: data.text.split(' ').filter(Boolean).length,
	};
};
